import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';

import { AuthProvider } from '../context/AuthProvider';
import Layout from '../layouts/Layout';
import PersistLogin from '../components/PersistLogin';
import Missing from '../pages/Missing';

import { authRoutes } from '../routes/auth';
import { proveedorPublicRoutes, proveedorAuthRoutes } from '../routes/proveedor';

// Styles
import 'react-toastify/dist/ReactToastify.css';
import '../assets/styles/index.scss';
import '../assets/styles/App.scss';

const queryClient = new QueryClient();

/**
 * Proveedor Entry Point
 * Desplegado en: proveedores.mecanicamx.com
 * Incluye rutas públicas (magic link) + rutas autenticadas (portal kanban)
 */
function ProveedorApp() {
  return (
    <div data-theme="light">
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <ToastContainer />
          <Routes>
            {/* All routes go through PersistLogin to rehydrate session if exists */}
            <Route element={<PersistLogin />}>
              {/* Public routes - no auth required but session rehydrated */}
              {proveedorPublicRoutes}

              {/* Auth routes */}
              <Route element={<Layout />}>
                {authRoutes}
                {proveedorAuthRoutes}
                <Route path="/" element={<Navigate to="/registro" replace />} />
                <Route path="*" element={<Missing />} />
              </Route>
            </Route>
          </Routes>
        </QueryClientProvider>
      </HelmetProvider>
    </div>
  );
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ProveedorApp />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
